import { DateTime } from 'luxon'

import type { PaidByKey, PaymentMethodKey } from '@functions/campaignContribution'

export type CampaignContributionModel = {
  amount?: number,
  cache_key: number,
  campaign_id?: number,
  data?: {
    api?: boolean,
    finance_application_id?: number,
    user_agent?: string,
  },
  dates: {
    created: {
        date: string,
        date_time: string,
    },
    received: {
      date: string,
    },
  },
  date_received?: string,
  id: number,
  paid_by?: PaidByKey,
  payment_method?: PaymentMethodKey,
  payment_received?: boolean,
  receipt?: string,
  reference: string,
  user_id?: number,
}

export type CampaignContributionRequestOptions = {}

const state = {
  amount: undefined,
  campaign_id: undefined,
  date_received: DateTime.now().toFormat('yyyy-MM-dd'),
  id: null,
  paid_by: 'vendor',
  payment_method: 'EFT',
  payment_received: undefined,
  receipt_data: '',
  reference: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'amount' },
  { key: 'campaign_id' },
  { key: 'date_received' },
  { key: 'paid_by' },
  { key: 'payment_method' },
  { key: 'reference' },
]

export default state
